import { useState, useMemo } from "react";
import Tabs, { Tab } from "react-awesome-tabs";
import "react-awesome-tabs/dist/react-awesome-tabs.css";
import DataTable from "react-data-table-component";
import {
  disbursementColumns,
  exportDisbursementData,
} from "../../utils/columns/disbursement";
import { baseUrl } from "../../utils/apiActions/dashboardApi";
import { Button, Form, Modal } from "react-bootstrap";
import { customStyles, formatNumber } from "../../utils/data/essential";
import Locations from "../../Component/Locations";
import moment from "moment";
import { CSVLink } from "react-csv";
import useAxios from "../../hooks/useAxios";
import { pullMoney } from "../../utils/roles";
const Disbursement = () => {
  const [loading, setLoading] = useState(false);
  const user = JSON.parse(localStorage.getItem("user"));
  const locations = JSON.parse(localStorage.getItem("locations"));
  const [disbursementData, setDisbursementData] = useState([]);
  const [keyword, setKeyword] = useState("");
  const [dataToPull, setDataToPull] = useState([])
  const [beneficiaryId, setBeneficiaryId] = useState(null);
  const [disbursementDate, setDisbursementDate] = useState(null);
  const [showDisbursementModal, setShowDisbursementModal] = useState(false)
  const [disabled, setDisabled] = useState(false);
  const [locationId, setLocationId] = useState(
    locations[locations.length - 1]?.id
  );
  const [activeTab, setActiveTab] = useState(0);
  const axiosInstance = useAxios()
  const roles = JSON.parse(localStorage.getItem("roles"));
  // switch tabs
  const handleTabSwitch = (active) => {
    setActiveTab(active);
  };
  const extractData = (data) => {
    let obj = {};
    let arr = [];
    data?.forEach((el) => {
      obj.beneficiary = el.beneficiary?.name;
      obj.accountNumber = el.beneficiary?.disbursementAccount.accountNumber;
      obj.transferId = el?.transferId;
      obj.date = moment(el?.date).format("DD/MM/YYYY");
      obj.transferDate = moment(el.transfer?.datetime).format("DD/MM/YYYY");
      obj.totalNetAmount = formatNumber(el?.totalNetAmount);
      obj.totalAgentCommission = el?.totalAgentCommission;
      obj.totalOperatorCommission = formatNumber(el?.totalOperatorCommission);
      obj.totalPaidAmount = formatNumber(el?.totalPaidAmount);
      obj.adjustment = el.totalAdjustmentAmount;
      obj.status = el.status?.name;
      arr.push(obj);
      obj = {};
    });
    setDisbursementData(arr.reverse());
    const dataToPull = data.filter((dt) => dt.status.id == 1);
    setDataToPull(dataToPull);
  };
  const filterData = (searchTerm) => {
    if (!searchTerm) {
      return disbursementData.reverse();
    }
    return disbursementData?.filter((dt) => {
      return (
        dt?.status.toLowerCase().includes(searchTerm.toLowerCase()) ||
        dt?.date?.includes(searchTerm.toLowerCase())
      )
    }).reverse();
  };
  const filteredData = useMemo(() => filterData(keyword), [disbursementData, keyword]);
  const fetchDisbursement = async () => {
    setLoading(true);
    const beneficiaryResponse = await fetch(
      `${baseUrl}/beneficiaries?locationId=${locationId}`,
      {
        method: "GET",
        headers: new Headers({
          Authorization: "Bearer " + user.access_token,
          Accept: "application/json",
          "Content-Type": "application/json",
        }),
      }
    );
    if (!beneficiaryResponse.ok) {
      throw new Error("Failed to fetch beneficiaries data");
    }
    const beneficiariesData = await beneficiaryResponse.json();
    if (beneficiariesData.length === 0) {
      setLoading(false);
      setDisbursementData([]);
      return;
    } else {
      const beneficiaryId = beneficiariesData[0]?.id;
      setBeneficiaryId(beneficiaryId);
      const disbursementResponse = await fetch(
        `${baseUrl}/beneficiaries/${beneficiaryId}/disbursements`,
        {
          method: "GET",
          headers: new Headers({
            Authorization: "Bearer " + user.access_token,
            Accept: "application/json",
            "Content-Type": "application/json",
          }),
        }
      );
      if (!disbursementResponse.ok) {
        throw new Error("Failed to fetch subscriber data");
      }
      setLoading(false);
      const disbursementData = await disbursementResponse.json();
      extractData(disbursementData);
    }
  };
  const handleDataFromLocationsComponent = (data) => {
    setLocationId(data?.locationId); 
  };
  const handlePullMoney = async (e) => {
    e.preventDefault();
    setDisabled(true);
    const locationName = locations[locations.length -1].name
    const payload = {
      disbursementDate,
      disbursementMessage: `Umutekano ${locationName} ${moment(
        disbursementDate
      ).format("DD-MM-YYYY")}`,
    };
    try {
      const res = await axiosInstance.post(`/beneficiaries/${beneficiaryId}/transfers`, payload);
      if (res.status >= 200 && res.status <= 300) {
        setShowDisbursementModal(false);
        setDisabled(false);
      }
        } catch (error) {
          console.error(error);
        }
  }
  return (
    <div>
      <Locations
        isFullLocation={false}
        sendDataToParent={handleDataFromLocationsComponent}
      />
      <div className='d-flex justify-content-center ml-5'>
        <Button
          onClick={() => {
            fetchDisbursement();
          }}
          className='custom-btn-color disbursement-btn'
        >
          {loading ? "Loading..." : "Search"}
        </Button>
        {roles?.some((role) => role.id === pullMoney) && (
          <>
            {disbursementData?.length > 0 && (
              <Button
                onClick={() => setShowDisbursementModal(true)}
                className='custom-btn-color disbursement-btn ml-2'
              >
                Pull Money
              </Button>
            )}
          </>
        )}
      </div>
      <div className='d-flex flex-wrap justify-content-center'>
        {disbursementData?.length > 0 && (
          <div className='flex-container' style={{ width: "100%" }}>
            <div className='quick-search-container'>
              <input
                type='text'
                className='form-control quick-search ml-2'
                placeholder='Quick search by status or date(01/06/2024)'
                onChange={(e) => {
                  setKeyword(e.target.value);
                }}
                style={{
                  bottom: filteredData.length === 0 ? -50 : -80,
                }}
              />
            </div>
          </div>
        )}
      </div>
      {disbursementData?.length > 0 && (
        <div className='d-flex justify-content-end mr-3'>
          <CSVLink
            data={filteredData}
            headers={exportDisbursementData}
            filename={`disbursement_report`}
          >
            <button
              type='button'
              className='btn btn-primary housesTableFilterBtn ml-2'
              disabled={disbursementData.length === 0}
              style={{
                backgroundColor:
                  disbursementData.length === 0 ? "#cbcbcb" : "#124db1",
                color: disbursementData.length === 0 ? "#000" : "",
                cursor: disbursementData.length === 0 ? "default" : "pointer",
              }}
            >
              Excel{" "}
              <i
                style={{ marginLeft: "1rem" }}
                className='fas fa-file-excel'
              ></i>
            </button>
          </CSVLink>
        </div>
      )}
      <div
        className='table-responsive datatables dataValidation-Wrap'
        style={{ width: "100%" }}
      >
        <DataTable
          columns={disbursementColumns}
          data={filteredData}
          defaultSortField='date' // Set the default sort field to the 'date' column
          defaultSortAsc={false} // Sort in descending order by default
          responsive={true}
          customStyles={customStyles}
          pagination
          highlightOnHover
          numberiped
          noHeader
        />
      </div>
      <Modal
        aria-labelledby='contained-modal-title-vcenter'
        centered
        show={showDisbursementModal}
      >
        <Modal.Header
          closeButton
          onClick={() => setShowDisbursementModal(false)}
        >
          <Modal.Title>Pulling Money</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handlePullMoney}>
            <label className='ml-2 mt-2'>Disbursement date</label>
            <select
              className='form-control'
              name='choice'
              onChange={(e) => setDisbursementDate(e.target.value)}
              required
            >
              <option value=''>Select date</option>
              {dataToPull?.map((data) => (
                <option value={data.date}>
                  {moment(data.date).format("DD-MM-YYYY")}
                </option>
              ))}
            </select>
            <div className='d-flex justify-content-center'>
              <Button className='custom-btn-color' type='submit' disabled={disabled}>
                Pull
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
};
export default Disbursement;
